export default {
  sorting: {
    dateAsc: 'du plus ancien au plus récent',
    dateDesc: 'du plus récent au plus ancien',
    amountAsc: 'montant croissant',
    amountDesc: 'montant décroissant',
  },
  newPortfolioName: 'Nouvelle assurance vie',
}
